import { type InfiniteData } from '@tanstack/react-query';

import { type MentoringCustomAttributesResponse } from 'hb-react/frontoffice/apps/Mentoring/requests/types';
import { type CustomAttributeType } from 'hb-react/frontoffice/apps/Mentoring/types';

export const flattenAttributes = (
  customAttributes: InfiniteData<MentoringCustomAttributesResponse> | undefined,
) => {
  const items = customAttributes?.pages || [];

  return items.reduce(
    (acc: Array<CustomAttributeType>, { data }) => [...acc, ...data],
    [],
  );
};
